function getInitials(name: string) {
  if (!name) return "U";

  const nameParts = name.split(" ").filter(Boolean);
  const initials =
    nameParts.length > 1
      ? nameParts
          .map((word) => word[0])
          .join("")
          .toUpperCase()
          .slice(0, 2)
      : name.slice(0, 2).toUpperCase();

  return initials;
}

export default getInitials;
